import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = process.env.REACT_APP_SITE_URL;

const upsert = (tag, keyAttr, keyVal, valueAttr, value) => {
  let el = document.head.querySelector(`${tag}[${keyAttr}="${keyVal}"]`);
  if (!value) return el?.remove();
  if (!el) {
    el = document.createElement(tag);
    el.setAttribute(keyAttr, keyVal);
    document.head.appendChild(el);
  }
  el.setAttribute(valueAttr, value);
};

export const Seo = ({ title, description, noindex = false }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = `${SITE}${pathname}`;
    document.title = title;
    upsert("meta", "name", "description", "content", description);
    upsert("meta", "property", "og:title", "content", title);
    upsert("meta", "property", "og:description", "content", description);
    upsert("meta", "property", "og:url", "content", url);
    upsert("link", "rel", "canonical", "href", noindex ? "" : url);
    upsert("meta", "name", "robots", "content", noindex ? "noindex, nofollow" : "");
  }, [title, description, noindex, pathname]);
  return null;
};
